import { Button, Col, Container, Form, Row } from "react-bootstrap";
import { Link, useNavigate, useParams } from "react-router-dom";
import Post_img from "../../../../../Assets/images/authBg1.png";
// img
// import i1 from "@/Assets/images/authBg.png";
// import dummy_video from "../../../../../Assets/images/";
import React, { useEffect, useState } from "react";
import Loader from "../../../../../components/Common/Loader";
import {
  catchAsync,
  checkResponse,
  removeUnderScoreAndCapitalizeFirstLetter,
} from "../../../../../utilities/utilities";
import TableLayout from "../../../../../components/TableLayout";
import TableActions from "../../../../../components/Common/TableActions";
import {
  GET_JOB_BY_ID,
  GET_USER_BY_ID,
} from "../../../../../services/ApiCalls";

// img
import i1 from "../../../../../Assets/images/user.png";
import moment from "moment";

const ViewJobPost = () => {
  const navigate = useNavigate();
  const [loader, setLoader] = useState(false);
  const [userDetails, setUserUserDetails] = useState();
  const [profileImage, setProfileImage] = useState();
  const { id } = useParams();
  const getData = catchAsync(async () => {
    setLoader(true);
    const res = await GET_JOB_BY_ID(id);
    const success = checkResponse({
      res,
      setData: setUserUserDetails,
      setLoader,
    });
    if (success) setProfileImage(res?.data?.data?.profileImage);
  }, setLoader);

  useEffect(() => {
    if (id) getData();
  }, [id]);

  return (
    <>
      {loader && <Loader />}
      <section className="userDetail py-3 position-relative">
        <Container>
          <Row>
            <Col lg="12">
              <div className="d-flex align-items-center gap-10">
                <Button
                  onClick={() => navigate(-1)}
                  className="border d-flex align-items-center p-2 text-white rounded"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="12"
                    height="12"
                    viewBox="0 0 10 16"
                    fill="none"
                  >
                    <path
                      d="M8.64707 0.473344C8.55514 0.381188 8.44594 0.308072 8.32572 0.258184C8.20549 0.208296 8.07661 0.182617 7.94644 0.182617C7.81628 0.182617 7.68739 0.208296 7.56717 0.258184C7.44694 0.308072 7.33774 0.381188 7.24582 0.473344L0.667065 7.05209C0.593675 7.12533 0.53545 7.21233 0.495723 7.3081C0.455996 7.40387 0.435547 7.50654 0.435547 7.61022C0.435547 7.7139 0.455996 7.81657 0.495723 7.91234C0.53545 8.00811 0.593675 8.0951 0.667065 8.16834L7.24582 14.7471C7.63373 15.135 8.25915 15.135 8.64707 14.7471C9.03498 14.3592 9.03498 13.7338 8.64707 13.3458L2.9154 7.60626L8.65498 1.86668C9.03498 1.48668 9.03498 0.853344 8.64707 0.473344Z"
                      fill="#fff"
                      stroke="#1E232C"
                      stroke-width="0.2"
                    />
                  </svg>
                </Button>
                <h4 className="mb-0 py-3 fw-bold text-dark text-capitalize">
                  Post Details
                </h4>
              </div>
            </Col>
            <Col lg="12" className="my-2">
              <div
                className="formWrpper px-lg-5 p-md-4 p-3 rounded"
                style={{ background: "#EEEEEE" }}
              >
                <Row className="justify-content-between">
                  {/* <Col lg="12" className="my-2">
                    <div className="text-end">
                      <div className="d-inline-flex align-items-center gap-10">
                        <label
                          htmlFor=""
                          className="form-label m-0 text-muted fw-sbold"
                        >
                          Status
                        </label>
                       <p>Active</p>
                      </div>
                    </div>
                  </Col> */}
                  {/* <Col lg="12" className="my-2">
                    <div
                      className="imgWrp text-center mx-auto"
                      style={{ maxWidth: "max-content" }}
                    >
                      <img
                        src={profileImage?.link || i1}
                        style={{ height: 140, width: 140 }}
                        alt=""
                        className="img-fluid rounded-circle object-fit-cover"
                      />
                    </div>
                  </Col> */}
                  <Col md={6} className="my-2">
                    <ul className="list-unstyled ps-0 mb-0 notLastBorder pe-lg-3">
                      <li className="py-3 d-flex align-items-center gap-10">
                        <p className="m-0 themeBlue fw-sbold w-25">Title:</p>
                        <h6 className="m-0 text-muted fw-bold w-50">
                          {userDetails?.title}
                        </h6>
                      </li>

                      <li className="py-3 d-flex align-items-center gap-10">
                        <p className="m-0 themeBlue fw-sbold w-25">
                          {" "}
                          Category :
                        </p>
                        <h6 className="m-0 text-muted fw-bold w-50">
                          {userDetails?.category?.catName}
                        </h6>
                      </li>
                      <li
                        className="py-3 d-flex align-items-center gap-10"
                        style={{
                          borderBottom: "1px solid #6e6e6e",
                        }}
                      >
                        <p className="m-0 themeBlue fw-sbold w-25">
                          {" "}
                          User Name :
                        </p>
                        <h6 className="m-0 text-muted fw-bold w-50">
                          {userDetails?.user?.name}
                        </h6>
                      </li>
                    </ul>
                  </Col>
                  <Col md={6} className="my-2">
                    <ul className="list-unstyled mb-0  ps-lg-3">
                      <li className="py-3 d-flex align-items-center gap-10">
                        <p className="m-0 themeBlue fw-sbold w-25">Price</p>
                        <p className="m-0 text-muted fw-bold w-50">
                          $ {userDetails?.price || ""}
                        </p>
                      </li>
                      <li
                        className="py-3 d-flex align-items-center gap-10"
                        style={{
                          borderTop: "1px solid #6e6e6e",
                          borderBottom: "1px solid #6e6e6e",
                        }}
                      >
                        <p className="m-0 themeBlue fw-sbold w-25">
                          Created at:
                        </p>
                        <h6 className="m-0 text-muted fw-bold w-50">
                          {moment(userDetails?.postDate).format(
                            "MM-DD-YYYY , HH:mm"
                          ) || ""}
                        </h6>
                      </li>
                      <li
                        className="py-3 d-flex align-items-center gap-10"
                        style={{
                          borderBottom: "1px solid #6e6e6e",
                        }}
                      >
                        <p className="m-0 themeBlue fw-sbold w-25">
                          {" "}
                          User Email :
                        </p>
                        <h6 className="m-0 text-muted fw-bold w-50">
                          {userDetails?.user?.email}
                        </h6>
                      </li>
                    </ul>
                  </Col>
                  <Col md={6}>
                    <li
                      className="py-3 d-flex align-items-center gap-10"
                      style={{
                        borderBottom: "1px solid #6e6e6e",
                      }}
                    >
                      <p className="m-0 themeBlue fw-sbold w-25"> Location:</p>
                      <h6 className="m-0 text-muted fw-bold w-50">
                        {userDetails?.postLocation?.address || ""}
                      </h6>
                    </li>
                  </Col>
                  <Col md={6}>
                    <li
                      className="py-3 d-flex align-items-center gap-10"
                      style={{
                        borderBottom: "1px solid #6e6e6e",
                      }}
                    >
                      <p className="m-0 themeBlue fw-sbold w-25">
                        Description:
                      </p>
                      <h6 className="m-0 text-muted fw-bold w-50">
                        {userDetails?.description}
                      </h6>
                    </li>
                  </Col>
                  <Col md={6}>
                    <li
                      className="py-3 d-flex align-items-center gap-10"
                      style={{
                        borderBottom: "1px solid #6e6e6e",
                      }}
                    >
                      <p className="m-0 themeBlue fw-sbold w-25">Status:</p>
                      <h6 className="m-0 text-muted fw-bold w-50">
                        {userDetails?.status}
                      </h6>
                    </li>
                  </Col>
                  <Col md={12}>
                    <div className="my-3">
                      <p className="m-0 themeBlue fw-sbold mb-2">Images:</p>
                    </div>
                    <Row className="g-3 mb-3">
                      {userDetails?.images?.map((imgObj, index) => (
                        <Col md={2} key={index}>
                          <div className="post-detail-img">
                            <img
                              className="img-fluid w-100"
                              src={imgObj.link}
                              alt={`post img ${index + 1}`}
                            />
                          </div>
                        </Col>
                      ))}
                    </Row>
                  </Col>
                  <Col md={12}>
                    <div className="post-vide-wrapper">
                      <p className="m-0 themeBlue fw-sbold mb-2">Video:</p>
                    </div>
                    <div className="post-video-wrapper">
                      <video controls>
                        <source
                          src="https://hlcstagings3.s3.us-east-2.amazonaws.com/17504244686241746696899284file_example_MP4_640_3MG.mp4"
                          type="video/mp4"
                        />
                        Your browser does not support the video tag.
                      </video>
                    </div>
                  </Col>
                </Row>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
};

export default ViewJobPost;
